import { parseSearchWith, stringifySearchWith } from '@tanstack/react-router';
import { fallback } from '@tanstack/zod-adapter';
import { z } from 'zod';

export const parseSearch = parseSearchWith(JSON.parse);
export const stringifySearch = stringifySearchWith(JSON.stringify);

/**
 * Safe string schema for TanStack Router search params (query params).
 * TanStack Router coerces numeric-looking query values to numbers before Zod
 * runs, so bare `z.string()` will reject values like `"123"`. This helper
 * uses `z.coerce.string()` wrapped in `fallback()` to handle that.
 * @see https://github.com/TanStack/router/issues/537
 */
export const searchParam = (defaultValue = '') => fallback(z.coerce.string(), defaultValue);
